import React, { useEffect, useState } from 'react';
import { PageHeader } from 'src/components/PageHeader';
import { GroupSitesWrapper } from './groupSites.styles';
import {
  SearchField,
  GridWrapper,
  GridItem,
  Button,
  Pagination,
  AsyncAutocompleteField,
  MultiAutocompleteField,
  Card,
  ProgressSpinner,
  SelectField,
} from '@sainsburys-tech/luna-react';
import Container from 'src/components/Container/Container';
import { NoRecordCard } from 'src/components/NoRecordCard';
import { debounce } from 'lodash';
import { ProfileCardLoader } from '../profiles/components/profileCardLoader';
import { gql } from '@apollo/client';
import { useSiteGroupsPage_PaginatedGroupsLazyQuery } from 'src/operations/generated/graphql';
import { GroupSiteCard } from '@sainsburys-tech/supplier-experience-group-site-card';

gql`
  query SiteGroupsPage_paginatedGroups($input: PaginatedGroupsInput!) {
    paginatedGroups(input: $input) {
      count
      page
      perPage
      groups {
        id
        name
        sites {
          value {
            id
            name
            supplierCode
            supplierNumber
            approvedDomains
            rejectedDomains
            status
            activeStatus
          }
        }
      }
    }
  }
`;

const pageSize = 21;

export const GroupSitesPage = () => {
  const [searchKey, setSearchKey] = useState('');
  const [identifier, setIdentifier] = useState('id');
  const [currentPage, setCurrentPage] = useState(1);
  const [seed, setSeed] = useState(1);

  const [filters, setFilters] = useState({
    identifier: identifier,
    value: searchKey,
    page: 1,
    pageSize: pageSize,
  });

  const [
    searchSiteGroups,
    {
      data: { paginatedGroups: { page = 1, groups = [], count = 1 } = {} } = {},
      error,
      loading,
    },
  ] = useSiteGroupsPage_PaginatedGroupsLazyQuery({
    variables: {
      input: {
        ...filters,
      },
    },
  });

  interface IOption {
    label: string;
    value: string;
    defaultSelected?: boolean;
  }

  const identifierOptions: IOption[] = [
    { label: 'SID', value: 'id', defaultSelected: true },
    { label: 'Name', value: 'name' },
    { label: 'Supplier code', value: 'supplierCode' },
    { label: 'Supplier number', value: 'supplierNumber' },
  ];

  const debouncedSetSearchKey = debounce(value => {
    setSearchKey(value);
  }, 500);

  const clearFilter = () => {
    setSearchKey('');

    setSeed(Math.random());
  };

  useEffect(() => {
    if (searchKey !== '') {
      const searchFilters = {
        value: searchKey,
        pageSize: pageSize,
        page: 1,
        identifier: identifier,
      };
      setCurrentPage(1);
      setFilters(searchFilters);
      searchSiteGroups();
    }
  }, [searchKey, identifier]);

  useEffect(() => {
    const searchFilters = {
      value: searchKey,
      pageSize: pageSize,
      identifier: identifier,
      page: currentPage,
    };
    if (currentPage !== 1) {
      setFilters(searchFilters);
      searchSiteGroups();
    }
  }, [currentPage]);

  return (
    <>
      <PageHeader
        heading={`All group sites`}
        breadcrumbLinks={[
          {
            name: 'Together With',
            link: '/',
          },
          {
            name: 'All sites',
            link: '',
          },
        ]}
      />
      <Container>
        <GroupSitesWrapper>
          <GridWrapper verticalAlign='middle'>
            {/* <GridItem size={{ md: '1/5', xs: '1/1' }}>
              <SelectField
                name='select-field-1'
                label='Select identifier'
                options={identifierOptions}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setIdentifier(e.target.value);
                }}
                defaultValue={identifierOptions[0].value}
              />
            </GridItem> */}
            <GridItem size={{ md: '1/5', xs: '1/1' }}>
              <SearchField
                name='search-sites'
                label='Search sites'
                onChange={(e: any) => {
                  debouncedSetSearchKey(e.target.value);
                }}
                key={seed}
                hasButton={false}
              />
            </GridItem>
          </GridWrapper>
          {loading ? (
            <>
              <ProfileCardLoader />
              <ProfileCardLoader />
              <ProfileCardLoader />
            </>
          ) : groups && groups.length > 0 ? (
            <>
              <GridWrapper>
                {groups?.map((groupSite: any) => (
                  <GridItem
                    key={groupSite.id}
                    size={{ md: '1/3' }}
                    className='ln-u-margin-bottom*3'
                  >
                    <GroupSiteCard
                      groupSite={{
                        id: groupSite.id,
                        name: groupSite.name,
                        sites: groupSite.sites.map((site: any) => site.value),
                      }}
                    />
                  </GridItem>
                ))}
              </GridWrapper>

              <div className='ln-u-text-align-center ln-u-margin-top*3'>
                <Pagination
                  showFirstAndLast
                  showPages
                  current={currentPage}
                  total={Math.ceil(count / pageSize)}
                  onChange={(page: number, e: any) => {
                    e.preventDefault();
                    setCurrentPage(page);
                  }}
                />
              </div>
            </>
          ) : (
            <NoRecordCard recordType='Group sites' searchTerm={searchKey} />
          )}
        </GroupSitesWrapper>
      </Container>
    </>
  );
};
